import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//------------To get the App Session data----------------
export const getAppSessionsThunk = createAsyncThunk(
  "appSession/getSessionData",
  async (data) => {
    try {
      if (data?.usertype) {
        const response = await api.get(
          `getAllAppSessions/${data.appType}/${data.usertype}`
        );
        return response.data;
      } else {
        const response = await api.get(`getAllAppSessions/${data?.appType}`);
        return response.data;
      }
    } catch (error) {
      console.error(`AppSessionGetApi_Error--> ${error}`);
    }
  }
);
//-----------To post the logout password response---------
export const logoutUserThunk = createAsyncThunk(
  "appSession/logoutUser",
  async (body) => {
    try {
      const response = await api.delete(
        `logoutUser/${body.userid}/${body.appType}/${body.password}`
      );
      return response.data;
    } catch (error) {
      console.error(`AppSessionPasswordResponseError---> ${error}`);
    }
  }
);
